export default "__VITE_ASSET__DKpzlsGs__"